var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('navigation'),(!_vm.getCheckout)?_c('shoes',{attrs:{"msg":"Shoes"}}):_c('check-out'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }